"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../../index");
function Banner(props) {
  return /*#__PURE__*/_react["default"].createElement("section", {
    className: 'student-center-banner'
  }, /*#__PURE__*/_react["default"].createElement(_index.NewBanner, {
    liveType: props === null || props === void 0 ? void 0 : props.liveType,
    lightTheme: props === null || props === void 0 ? void 0 : props.lightTheme,
    backgroundVideoUrl: props === null || props === void 0 ? void 0 : props.backgroundVideoUrl,
    // backgroundUrlLogo={''}
    title: props === null || props === void 0 ? void 0 : props.title,
    content: props === null || props === void 0 ? void 0 : props.content,
    backgroundUrlLogo: props === null || props === void 0 ? void 0 : props.backgroundUrlLogo,
    buttonList: props === null || props === void 0 ? void 0 : props.buttonList,
    onCallback: props === null || props === void 0 ? void 0 : props.onCallback
  }), /*#__PURE__*/_react["default"].createElement(_index.StudentCenterHeader, {
    anchor: props === null || props === void 0 ? void 0 : props.anchor
  }));
}
var _default = exports["default"] = Banner;